import React from 'react';
import { Link } from 'react-router-dom';

const Offline: React.FC = () => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gray-100">
            <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
                <div className="flex items-center justify-center w-16 h-16 mx-auto bg-yellow-100 rounded-full">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-8 h-8 text-yellow-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                    </svg>
                </div>

                <h1 className="text-2xl font-bold text-center text-gray-800">You're Offline</h1>

                <p className="text-center text-gray-600">
                    It looks like you've lost your internet connection. Some features may be limited until you're back online.
                </p>

                <div className="space-y-4">
                    <div className="p-4 bg-gray-50 rounded-md">
                        <h2 className="font-medium text-gray-700">Available Offline:</h2>
                        <ul className="mt-2 ml-5 space-y-1 list-disc text-gray-600">
                            <li>
                                <Link to="/offline/projects" className="text-blue-600 hover:underline">
                                    View cached projects
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div className=' flex items-center gap-2 p-4 bg-gray-50 rounded-md'>
                        <div className='font-medium text-gray-700'>Back Online? </div><div onClick={() => window.history.back()} className=' text-blue-600 hover:underline cursor-pointer'>Go Back to Previous Page</div>
                    </div>
                   
                </div>
            </div>
        </div>
    );
};

export default Offline; 